import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSendOtpCodeMutation } from "../../../Store/Slices/rtk";
import { setAuthData } from "../../../Store/Slices/AuthSlice/authSlice";
import { GradientBorderBox } from "../../../Components";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { notify } from "../../../App";

export default function OTP() {
  const theme = useTheme();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sendOtpCode, { isLoading }] = useSendOtpCodeMutation();

  const formik = useFormik({
    initialValues: {
      phone_number: "",
    },
    validationSchema: Yup.object({
      phone_number: Yup.string()
        .required("شماره تلفن الزامی میباشد")
        .matches(/^(?:\+98|0)?9\d{9}$/, "فرمت نادرست میباشد"),
    }),
    onSubmit: async (values) => {
      try {
        let phone = values.phone_number;
        if (phone.startsWith("0")) phone = phone.slice(1);

        const fullPhone = "0" + phone;

        const response = await sendOtpCode(fullPhone);
        if (response?.error?.status === 429)
          return notify("درخواست بیش از حد مجاز", "error");
        const tmpToken = response?.data?.tmp_token;
        if (!tmpToken) throw new Error("No tmp_token in response");

        dispatch(
          setAuthData({
            phoneNumber: fullPhone,
            tempToken: tmpToken,
          })
        );

        navigate("verify");
      } catch (error) {
        console.error("Failed to send OTP:", error);
        toast.error('"فرمت نادرست میباشد"');
      }
    },
  });

  return (
    <>
      <Stack
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh",
        }}
      >
        <Stack
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            height: { xs: "300px", md: "400px", xl: "505px" },
            backgroundImage: 'url("/media/Layout/AuthLayout/OTP/group.svg")',
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            padding: "30px",
            width: "100%",
            maxWidth: { xs: "270px", sm: "350px", md: "600px", xl: "800px" },
          }}
        >
          {/* <Box component={'img'} sx={{width:'100%' , height:'100%', zIndex:'-1', position:'absolute' , top:'0' , left:'0'}} src="/media/Layout/AuthLayout/OTP/Vector.svg"/> */}
          {/* Back Button */}
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              position: "absolute",
              top: { xs: "10px", sm: "15px" },
              left: { xs: "10px", sm: "15px" },
              color: theme.palette.primary.main,
              zIndex: 2001,
            }}
          >
            <KeyboardBackspaceIcon />
          </IconButton>
          {/* Form */}
          <Stack
            onSubmit={formik.handleSubmit}
            component={"form"}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
              gap: "20px",
              width: { xs: "80%", sm: "50%", md: "50%", lg: "50%" },
              height: { xs: "20%", sm: "30%", md: "40%" },
              mt: { xs: "0px", sm: "0px", md: "50px", xl: "80px" },
              mx: "auto",
            }}
          >
            <Stack sx={{ width: "100%" }}>
              <Typography
                sx={{
                  fontSize: { lg: "24px", sm: "18px", xs: "15px" },
                  mt: { lg: "15px", md: "15px", xs: "40px" },
                  textAlign: "center",
                  fontWeight: "bold",
                  // color: theme.palette.extra.darkBlue,
                  mb: "1.5rem",
                }}
              >
                ورود
              </Typography>

              <Typography
                sx={{
                  fontSize: { lg: "15px", md: "12px", xs: "12px" },
                  textAlign: "right",
                  my: "8px",
                  // color: theme.palette.extra.darkBlue,
                }}
              >
                شماره تماس
              </Typography>
              <Stack>
                <TextField
                  variant="outlined"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      padding: 0,
                      bgcolor: theme.palette.background.paper,
                      border: "1px solid gray",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px",
                      textAlign: "left",
                    },
                    "& .MuiInputBase-input::placeholder": {
                      // color: theme.palette.warning.main,
                      opacity: 1,
                    },

                    // borderRadius: "12px",
                    // height: "37px",
                    mb: { lg: "20px", md: "15px", xs: "0px" },
                  }}
                  name="phone_number"
                  value={formik.values.phone_number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.phone_number &&
                    Boolean(formik.errors.phone_number)
                  }
                  helperText={
                    formik.touched.phone_number && formik.errors.phone_number
                  }
                />
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ color: theme.palette.secondary.main, mt: "1.5rem" }}
                >
                  تایید
                </Button>
              </Stack>
              {/* <Button variant="text" sx={{ my: "10px" }}>
                ثبت نام
              </Button> */}
            </Stack>
          </Stack>
          <GradientBorderBox />
        </Stack>
      </Stack>
    </>
  );
}
